import { useMemo } from 'react';

import { useChartLocale } from 'components/charts/hooks/use-chart-locale';

const NUMERIC_SCALES = ['linear', 'log', 'symlog', 'pow', 'sqrt'];

type AxisLike = { scaleType?: string; valueFormatter?: unknown; data?: readonly unknown[] };

// Native numeric axes format ticks in English. Numeric axes without their own formatter get the chart
// locale formatter; category, time, and date axes keep native formatting.
export const useLocaleAxes = <T extends AxisLike>(axes: readonly T[] | undefined, categoryByDefault = false) => {
  const { axisValueFormatter } = useChartLocale();

  return useMemo(
    () =>
      axes?.map((axis) => {
        const numeric = axis.scaleType
          ? NUMERIC_SCALES.includes(axis.scaleType)
          : !categoryByDefault && !axis.data?.some((value) => typeof value !== 'number');

        return numeric && axis.valueFormatter === undefined ? { ...axis, valueFormatter: axisValueFormatter } : axis;
      }),
    [axes, categoryByDefault, axisValueFormatter]
  );
};
